function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import PropTypes from 'prop-types';
import React from 'react';
import text from '../../text';
import { IconButton } from '../button';
import Container from '../containers/Container';
import classNames from 'classnames';
// Call to Action Button
var CtaButton = function(param) {
    var show = param.show, header = param.header, description = param.description, _param_tooltip = param.tooltip, tooltip = _param_tooltip === void 0 ? null : _param_tooltip, handleClick = param.handleClick, _param_titleClassNames = param.titleClassNames, titleClassNames = _param_titleClassNames === void 0 ? '' : _param_titleClassNames, _param_subTitleClassNames = param.subTitleClassNames, subTitleClassNames = _param_subTitleClassNames === void 0 ? '' : _param_subTitleClassNames, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_isSecondary = param.isSecondary, isSecondary = _param_isSecondary === void 0 ? true : _param_isSecondary, isTertiary = param.isTertiary;
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: handleClick,
        className: classNames('cta-button', className)
    }, /*#__PURE__*/ React.createElement(Container, _object_spread_props(_object_spread({
        noBorder: true
    }, isSecondary && {
        isSecondary: isSecondary
    }, isTertiary && {
        isTertiary: isTertiary
    }), {
        className: "d-flex justify-content-between p-3 align-items-center"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "text-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row align-items-center"
    }, /*#__PURE__*/ React.createElement("p", {
        className: classNames('font-weight-bold m-0 mr-2', titleClassNames)
    }, header), tooltip), /*#__PURE__*/ React.createElement("p", {
        className: classNames('m-0 font-12', subTitleClassNames)
    }, description)), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column add-button-container"
    }, /*#__PURE__*/ React.createElement(IconButton, {
        iconProps: {
            isOriginal: true
        },
        icon: "plus-filled"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "m-0 font-weight-bold"
    }, text('add')))));
};
CtaButton.propTypes = {
    show: PropTypes.bool.isRequired,
    header: PropTypes.string.isRequired,
    tooltip: PropTypes.oneOfType([
        PropTypes.string,
        null
    ]),
    description: PropTypes.string,
    handleClick: PropTypes.func,
    className: PropTypes.string,
    titleClassNames: PropTypes.string,
    subTitleClassNames: PropTypes.string,
    isSecondary: PropTypes.bool,
    isTertiary: PropTypes.bool
};
CtaButton.defaultProps = {
    show: true,
    description: ''
};
export default CtaButton;
